import { mapLanguageDtoToItemLabelModel } from '../../shared/utils/mapping/mapping.utils';
import { AppDetailFormFormikModel } from '../components/ui/AppDetailsForm/models/app-detail-form-formik.model';
import { AppModel } from '../models/app.model';

export const appModelToFormik = (data: AppModel): AppDetailFormFormikModel => ({
  categoriesIds: data.categories.map(category => ({
    id: category.id,
    label: category.name,
  })),
  countriesRegionsIds: data.countriesRegions.map(countryRegion => ({
    id: countryRegion.id,
    label: countryRegion.name,
  })),
  defaultLanguageIso: mapLanguageDtoToItemLabelModel(data.defaultLanguage),
  iconId: data.icon.id,
  longDescription: data.longDescription,
  name: data.name,
  privacyPolicy: data.privacyPolicy,
  publisherName: data.publisherName as string,
  screenshotsIds: data.screenshots.map(screenshot => screenshot.id),
  shortDescription: data.shortDescription,
  website: data.website,
  packageName: data.packageName,
  isFeatured: data.isFeatured,
});
